module.exports = __webpack_public_path__ + "static/media/master.f65c3b15.svg";